import eventBus from "@sd-utility/eventbus";
import { getPLPContentPage } from "client/api/amplience";
import { FACET_UPDATE_EVENT } from "client/utils/consts";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { AmpPLPContentPage } from "types/amplience";
import useGlobalConfig from "./GlobalConfig";

export interface SlotConfig
  extends Pick<AmpPLPContentPage, "heroBanners" | "quickFilters" | "inGridBanners" | "modals"> {}

const SlotConfigContext = createContext<SlotConfig>({});
SlotConfigContext.displayName = "SlotConfigContext";

export const SlotConfigProvider: React.FC<React.PropsWithChildren<{ value?: SlotConfig; initPath: string }>> = ({
  value: initValue,
  initPath,
  ...props
}) => {
  const { brand } = useGlobalConfig();
  const initRender = useRef(true);
  const [path, setPath] = useState(initPath);
  const [value, setValue] = useState(initValue || {});

  useEffect(() => {
    const subscription = eventBus.subscribe(FACET_UPDATE_EVENT, (e) => {
      const url = new URL(e.path, location.origin);
      setPath(url.pathname);
    });

    return subscription.unsubscribe;
  }, []);

  useEffect(() => {
    const popStateListener = () => setPath(location.pathname);
    window.addEventListener("popstate", popStateListener);
    return () => window.removeEventListener("popstate", popStateListener);
  }, []);

  useEffect(() => {
    if (initRender.current) {
      initRender.current = false;
      return;
    }

    (async () => {
      const res = await getPLPContentPage(brand, path);
      setValue({
        heroBanners: res?.heroBanners,
        quickFilters: res?.quickFilters,
        inGridBanners: res?.inGridBanners,
        modals: res?.modals,
      });
    })();
  }, [brand, path]);

  return <SlotConfigContext.Provider {...props} value={value} />;
};

const useSlotConfig = () => useContext(SlotConfigContext);
export default useSlotConfig;
